import { SharedContactService } from './../shared-contact.service';
import { Component, OnInit, ViewChild } from '@angular/core';

import { Store } from '@ngrx/store';
import { SharedOwnerDashboardService } from 'src/app/shared/layout/owner-dashboard/shared-owner-dashboard.service';
import { ContactCreateComponent } from '../create/create.component';
import { ContactItem } from '../models/contacts';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css'],
})
export class ContactsComponent implements OnInit {
  loaded = true;
  contactsList: ContactItem[] = [
    {
      id: 1,
      type: 'instructor',
      name: 'John Doe',
      email: 'john.doe@example.com',
      createdAt: 1622520000000,
    },
    {
      id: 2,
      type: 'instructor',
      name: 'Jane Smith',
      email: 'jane.smith@example.com',
      createdAt: 1622606400000,
    },
    {
      id: 3,
      type: 'instructor',
      name: 'Emily Johnson',
      email: 'emily.johnson@example.com',
      createdAt: 1622692800000,
    },
    {
      id: 4,
      type: 'instructor',
      name: 'Michael Brown',
      email: 'michael.brown@example.com',
      createdAt: 1622779200000,
    },
    {
      id: 5,
      type: 'instructor',
      name: 'Sarah Davis',
      email: 'sarah.davis@example.com',
      createdAt: 1622865600000,
    },
  ];

  @ViewChild('createModal') createModal: ContactCreateComponent;

  constructor(
    public sharedContactService: SharedContactService,
    public sharedOwnerDashboardService: SharedOwnerDashboardService,
    private store: Store
  ) {}

  async ngOnInit() {
    this.sharedOwnerDashboardService.setTitle(
      {
        main: 'Contacts',
        sub: 'On Learmo, Contacts encompass all individuals in your account, including instructors, students, leads, and others.',
      },
      [ContactCreateComponent]
    );
    this.sharedOwnerDashboardService.setBreadcrumbs({ base: 'contact' });

    await this.sharedContactService.getContacts();
  }

  handleEditContact(contact: ContactItem) {
    if (this.createModal) {
      this.createModal.editContact = contact;
      this.createModal.openModalProcess();
    }
  }
}
